import { combineReducers } from 'redux';
import campaignReducer from './features/campaign/reducer';
import configurationReducer from './features/configuration/reducer';
import societyReducer from './features/society/reducer';
import importContactReducer from './features/importContact/reducer';
import toastsReducer from './features/toasts/reducer';
import partnerReducer from './features/partner/reducer';
import mailsReducer from './features/mail/reducer';
import rolesReducer from './features/roles/reducer';
import projectReducer from './features/project/reducer';
import progressBarReducer from './features/progressBar/reducer';
var rootReducer = combineReducers({
    campaign: campaignReducer,
    configuration: configurationReducer,
    society: societyReducer,
    importContact: importContactReducer,
    partner: partnerReducer,
    toasts: toastsReducer,
    mails: mailsReducer,
    roles: rolesReducer,
    project: projectReducer,
    progress: progressBarReducer,
});
export default rootReducer;
